import { Routes, Route } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import UsersPage from "./pages/UsersPage";
import RolesPage from "./pages/RolesPage";
import PermissionsPage from "./pages/PermissionsPage";
import ServiceMasterPage from "./pages/ServiceMasterPage";

const AdminRoutes = () => {
  return (
    <Routes>

      <Route element={<AdminLayout />}>

        <Route index element={<UsersPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="permissions" element={<PermissionsPage />} />
        <Route path="Services" element={<ServiceMasterPage />} />

      </Route>

    </Routes>
  );
};

export default AdminRoutes;
